import { Template } from "app/main/pages/edit-template/edit-template.dto";
import { HttpActionState } from "app/main/pages/users/userslisting/store/users-listing.reducers";
import { RecipientRole } from 'app/main/pages/edit-template/edit-template.dto';

export interface OnlineContractState {
    template: Template,
    fetchOnlineContractRequestState:HttpActionState,
    signOnlineContractRequestState:HttpActionState,
    signOnlineContractErrorCode: string | null,
    sendOnlineContractInvitationRequestState:HttpActionState,
    visitedRoles: RecipientRole[];
}

export const InitialState: OnlineContractState = {
    template: null,
    fetchOnlineContractRequestState: HttpActionState.Init,
    signOnlineContractRequestState: HttpActionState.Init,
    signOnlineContractErrorCode: null,
    sendOnlineContractInvitationRequestState: HttpActionState.Init,
    visitedRoles: [],
}

export const featureKey = 'OnlineContract';

// The backend's code for an e-form refused because an eID result is missing, expired or already used.
export const EID_NOT_COMPLETED_CODE = 'eid_not_completed';